'use client';

import Image from 'next/image';
import Markdown from 'components/Markdown';
import ProjectStat from 'components/ProjectStat';
import { canOptimizeImage } from '@/lib/utils';

export default function ProjectFooter({ project }) {
  if (!project) {
    return null;
  }

  const { name, logo, description, tags } = project;

  return (
    <div className="flex flex-col p-4">
      <div className="flex">
        {/* Avatar */}
        {logo && (
          <div className="hidden md:flex w-20 md:mr-8">
            <Image
              src={logo}
              alt={`Logo for ${name}`}
              height={80}
              width={80}
              unoptimized={!canOptimizeImage(logo)}
            />
          </div>
        )}

        {/* Title */}
        <div className="flex flex-col space-y-2">
          <p className="text-h2 md:text-h1">{name}</p>
          <div className="flex flex-wrap">
            {tags?.split(',')?.map((t, i) => (
              <ProjectStat className="mb-2 md:mb-0 mr-2" key={`${name}-${t?.trim() || i}`}>
                {t?.trim()}
              </ProjectStat>
            ))}
          </div>
        </div>
      </div>

      {/* bottom */}
      <div className="w-full my-4 border-t-[1px] border-semitrans" />
      <div className="w-full overflow-x-auto">
        <Markdown>{description}</Markdown>
      </div>
    </div>
  );
}
